import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setError, setSuccess } from "../../reducers/appSlice";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import moment from 'moment';

import * as Yup from "yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import { visuallyHidden } from "@mui/utils";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCellMui from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";

// import ReactExport from "react-export-excel";
import ReactExport from "@ibrahimrahmani/react-export-excel";

import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import EditOutlined from "@mui/icons-material/EditOutlined";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';

import MinimalPage from "../../layout/MinimalPage";
import api from "../../service/api";
import BuscadorOrganismo from "../../commons/BuscadorOrganismo";
import ReporteArchivados from "./ReporteArchivados";
import Archivar from "../../commons/Archivar";
import Accion from "../../components/Accion";

// Dialogos de botones de acción
import ConfirmDialog from "../../components/ConfirmDialog";

const TableCellHead = styled(TableCellMui)(({ theme }) => ({
  color: "#3c4b64",
  padding: theme.spacing(1, 1, 1, 1),
}));

const TableCell = styled(TableCellMui)(({ theme }) => ({
  padding: theme.spacing(1, 1, 1, 1),
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const EnhancedTableToolbar = (props) => {
  const { datos } = props;
  const [alignment, setAlignment] = React.useState("left");

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  return (
    <>
      <Toolbar disableGutters>
        <Grid container spacing={1} align="left">
          <Grid item align="left">
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                border: (theme) => `1px solid ${theme.palette.divider}`,
                flexWrap: "wrap",
              }}
            >
              <StyledToggleButtonGroup
                size="small"
                value={alignment}
                exclusive
                onChange={handleAlignment}
                aria-label="text accionGrupal"
              >
                <ReporteArchivados datos={datos} fechas={props.fechasPdf} tipoTramite={props.tipoTramitePdf} />
              </StyledToggleButtonGroup>
              <ExcelFile element={(<ToggleButton
                                      value="exportar"
                                      title="Exportar a Excel"
                                      sx={{ border: 0, "&.Mui-disabled": { border: 0, } }}
                                      disabled={datos.length === 0}
                                    >
                                      <FileDownloadOutlinedIcon />
                                    </ToggleButton>)} filename="Archivados">
                <ExcelSheet data={datos} name="Listado de archivados">
                    <ExcelColumn label="Número de expediente" value="expediente"/>
                    <ExcelColumn label="Número de trámite interno" value="tramiteInterno"/>
                    <ExcelColumn label="Fecha de inicio" value="fechaInicio"/>
                    <ExcelColumn label="Organismo generador" value="generador"/>
                    <ExcelColumn label="Iniciadores" value="iniciador"/>
                    <ExcelColumn label="Fecha de archivo" value="fechaArchivoParaExcel"/> 
                    <ExcelColumn label="Asunto" value="asunto"/> 
                    <ExcelColumn label="Cantidad de fojas" value="folios"/> 
                </ExcelSheet>                
              </ExcelFile>
            </Paper>
          </Grid>
          <Grid item sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            {datos.length > 300 ? <Typography variant="aclaracion">La cantidad de registros para imprimir superan los 300. Por favor realizá una nueva búsqueda.</Typography> : null}
          </Grid>
        </Grid>
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const ConsultaArchivados = (props) => {
  const { resetearTabla } = props;

  const [buscandoOrganismo, setBuscandoOrganismo] = useState(false);
  const [fechasPdf, setFechasPdf] = useState("");
  const [tipoTramitePdf, setTipoTramitePdf] = useState("expediente");

  const dispatch = useDispatch();

  const leyendaOrganismo =
    "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Archivados", ruta: "" },
  ];

  const [datos, setDatos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = React.useState(0);

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Expediente");

  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [lblCriterios, setLblCriterios] = useState("Criterios de búsqueda");
  const [submitting, setSubmitting] = useState(false);
  const [expand, setExpand] = React.useState(true);

  const [tipoTramite, setTipoTramite] = useState("expediente");
  const [labelNroExpediente, setLabelNroExpediente] = useState("Número de expediente");

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - datos.length) : 0;


  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleOrganismo = (organismo = null) => {
    if (organismo !== null) {
      formik.setFieldValue("codigoOrganismo", organismo.id);
      formik.setFieldValue("organismo", organismo.descOrgCompleta);
    } else {
      formik.setFieldValue("codigoOrganismo", "");
      formik.setFieldValue("organismo", "");
    }
  };

  const buscarOrganismoPorCodigo = (codigoOrganismo) => {
    setBuscandoOrganismo(true);
    api
      .buscarOrganismo({
        id: codigoOrganismo,
        descripcion: "",
        alta: "N",
        accion: "consulta",
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          handleOrganismo(res.data[0]);
        } else {
          handleOrganismo();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismo();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismo(false);
      });
  };

  const handleorfId = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        buscarOrganismoPorCodigo(event.target.value);
      }
    } else if (
      event.type === "blur" &&
      formik.values.organismo === "" &&
      event.target.value !== "" &&
      event.target.value !== null
    ) {
      buscarOrganismoPorCodigo(event.target.value);
    }
    // }
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeorfId = (event) => {
    if (
      formik.values.organismo !== "" &&
      formik.values.organismo !== null
    )
      handleOrganismo();
    if (/^\d*$/.test(event.target.value)) formik.setFieldValue("orfId", event.target.value);
  };

  const recircular = async (tramiteId, tipoTramite, numero) => {
    api
      .recircular({
        traId: tramiteId,        
      })
      .then((res) => {        
        dispatch(setSuccess("Se recirculó el "+tipoTramite+" "+numero));
      })
      .catch((e) => {
        //dispatch(setError("Error al recircular"));
        dispatch(setError(e.response.data.error));
      })
      .finally(() => {
        //setBuscandoOrganismo(false);
        buscarTramites(formik.values);
      });
  };


  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const headCells = [
    {
      id: "expediente",
      numeric: true,
      disablePadding: true,
      label: tipoTramite === "expediente" ? "Expediente" : "Trámite Interno",
      width: 150,
      align: "center",
    },
    {
      id: "asunto",
      numeric: false,
      disablePadding: false,
      label: "Asunto",
      width: 300,
      align: "left",
    },
    {
      id: "fechaArchivo",
      numeric: false,
      disablePadding: false,
      label: "Fecha de archivo",
      width: 300,
      align: "left",
    },
    {
      id: "descOrgArchCompleta",
      numeric: false,
      disablePadding: false,
      label: "Organismo que archivó",
      width: 300,
      align: "left",
    },
    {
      id: "folios",
      numeric: true,
      disablePadding: false,
      label: "Folios",
      width: 50,
      align: "center",
    },
    {
      id: "ubicacion",
      numeric: false,
      disablePadding: false,
      label: "Ubicación física",
      width: 300,
      align: "left",
    },
    {
      id: "vigente",
      numeric: false,
      disablePadding: false,
      label: "Vigente",
      width: 50,
      align: "center",
    },
  ];

  function EnhancedTableHead(props) {
    const {
      order,
      orderBy,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCellHead
              key={headCell.id}
              align={headCell.align}
              padding="normal"
              sortDirection={orderBy === headCell.id ? order : false}
              width={headCell.width}              
            >
              { headCell.label !== "Fecha de archivo" ? (              
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  <b>{headCell.label}</b>
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "ordenado descendente"
                        : "ordenado ascendente"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : ( <b>{headCell.label}</b> )
            }
            </TableCellHead>
          ))}
          <TableCellHead width={100} align="center">
            <b>Acciones</b>
          </TableCellHead>
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
              <KeyboardArrowLeft />
            )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
              <KeyboardArrowRight />
            )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  const validationSchema = Yup.object().shape({
    tipoTramite: Yup.string(),
    nroExpediente: Yup.number()
      .integer("Debe ingresar un número entero")
      .positive("Debe ingresar un número positivo"),
    soporte: Yup.string(),
    orfId: Yup.number(),
    organismo: Yup.string(),
    ubicacion: Yup.string(),
    fechaDesde: Yup.date().when(["nroExpediente"], {
      is: (nroExpediente) => !(nroExpediente),
      then: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida"),
    }),
    fechaHasta: Yup.date().when(["nroExpediente"], {
      is: (nroExpediente) => !(nroExpediente),
      then: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .max(new Date(), "Fecha no válida")
      .min(Yup.ref("fechaDesde"), "Rango fecha no válido"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      soporte: "T",
      fechaDesde: "",
      fechaHasta: "",
      orfId: "",
      ubicacion: "",
      tipoTramite: "expediente",
      nroExpediente: "",
      organismo: "",
    },
    lblCriterios: "Criterios de búsqueda",
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setDatos([]);
      setLblCriterios("Criterios de búsqueda");
      setPage(0);

      formik.values.ubicacion !== "" ||
        formik.values.soporte !== "T" ||
        formik.values.fechaDesde !== "" ||
        formik.values.fechaHasta !== "" ||
        formik.values.nroExpediente !== "" ||
        formik.values.orfId !== ""
        ? setLblCriterios("Criterios aplicados")
        : setLblCriterios("Criterios de búsqueda");
      buscarTramites(values);
    },
    onReset: () => {      
      setDatos([]);
      formik.values.fechaDesde = "";
      formik.values.fechaHasta = "";
      setLblCriterios("Criterios de búsqueda");
      setLabelNroExpediente("Número de expediente");
    },
  });

  const buscarTramites = (filtros) => {
    setSubmitting(true);
    setDatos([]);
    api
      .listarArchivados({
        soporte: formik.values.soporte,
        fechaDesde: formik.values.fechaDesde,
        fechaHasta: formik.values.fechaHasta,
        orfId: formik.values.orfId,
        ubicacionFisica: formik.values.ubicacion,
        tipoTramite: formik.values.tipoTramite,
        nroExpediente: formik.values.nroExpediente,
      })
      .then((res) => {
        setDatos(res.data);
        let fechaDesde = formik.values.fechaDesde.split("-");
        let fechaHasta = formik.values.fechaHasta.split("-");
        setFechasPdf("desde el " + fechaDesde[2] + "/" + fechaDesde[1] + "/" + fechaDesde[0] + " al " + fechaHasta[2] + "/" + fechaHasta[1] + "/" + fechaHasta[0]);
        setTipoTramitePdf(formik.values.tipoTramite);
        setSelected([]);
      })
      .catch((e) => {
        dispatch(setError(e.response.data.error));
        console.log("Error al cargar los datos");
      })
      .finally(() => setSubmitting(false));
  };

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };

  const handleChangeTipoTramite = (event) => {
    if (event.target.value === "expediente") {
      setTipoTramite("expediente");
      setLabelNroExpediente("Número de expediente");
    } else {
      setTipoTramite("tramite");
      setLabelNroExpediente("Número de trámite interno");
    }
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeSoporte = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaDesde = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeFechaHasta = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  const handleChangeUbicacion = (event) => {
    formik.handleChange(event);
    setDatos([]);
    setLblCriterios("Criterios de búsqueda");
  };

  return (
    <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth>
      <Accordion
        sx={{ pl: 1, pr: 1 }}
        disableGutters
        expanded={expand}
        onChange={toggleAcordion}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-filtros"
          id="panel-filtros"
          sx={{ height: "50px" }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <FilterAltOutlinedIcon
              color={submitting ? "secondary" : "primary"}
              sx={{ mr: 1, display: { xs: "none", md: "inline" } }}
            />
            <Typography variant="cuerpo">{lblCriterios}</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 1 }}>
          <form
            id="buscador"
            name="buscador"
            onSubmit={formik.handleSubmit}
            onReset={formik.handleReset}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1} sx={{ pl: 2, pr: 2, mb: 0 }}>
              <Grid item xs={12} lg={12} sx={{ mb: 0 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={8}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} lg={4}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            formik.touched.tipoTramite &&
                            Boolean(formik.errors.tipoTramite)
                          }
                          fullWidth
                        >
                          <InputLabel id="tipoTramiteLabel">
                            Tipo de trámite
                          </InputLabel>
                          <Select
                            labelId="tipoTramiteLabel"
                            id="tipoTramite"
                            name="tipoTramite"
                            variant="outlined"
                            label="Tipo de trámite"
                            value={formik.values.tipoTramite}
                            onChange={handleChangeTipoTramite}
                          >
                            <MenuItem value="expediente">
                              EXPEDIENTES
                            </MenuItem>
                            <MenuItem value="tramite">TRÁMITES INTERNOS</MenuItem>
                          </Select>
                          <FormHelperText>
                            {formik.touched.tipoTramite &&
                              formik.errors.tipoTramite}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <TextField
                          id="nroExpediente"
                          name="nroExpediente"
                          label={labelNroExpediente}
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={formik.values.nroExpediente}
                          onChange={handleChangeTextField}
                          error={
                            formik.touched.nroExpediente &&
                            Boolean(formik.errors.nroExpediente)
                          }
                          helperText={
                            formik.touched.nroExpediente && formik.errors.nroExpediente
                          }
                        />
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            formik.touched.soporte && Boolean(formik.errors.soporte)
                          }
                          fullWidth
                        >
                          <InputLabel id="soporteLabel">Soporte</InputLabel>
                          <Select
                            labelId="soporteLabel"
                            id="soporte"
                            name="soporte"
                            variant="outlined"
                            label="Soporte"
                            value={formik.values.soporte}
                            onChange={handleChangeSoporte}
                          >
                            <MenuItem value="T" selected>TODOS</MenuItem>
                            <MenuItem value="S">DIGITAL</MenuItem>
                            <MenuItem value="N">PAPEL</MenuItem>
                          </Select>
                          <FormHelperText>
                            {formik.touched.soporte && formik.errors.soporte}
                          </FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={12} sx={{ mb: 0 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} lg={2}>
                            <TextField
                              id="orfId"
                              name="orfId"
                              label="Código de organismo"
                              variant="outlined"
                              size="small"
                              fullWidth
                              value={formik.values.orfId}
                              onChange={handleChangeorfId}
                              onKeyDown={handleorfId}
                              onBlur={handleorfId}
                              error={
                                formik.touched.orfId &&
                                Boolean(formik.errors.orfId)
                              }
                              helperText={
                                formik.touched.orfId &&
                                formik.errors.orfId
                              }
                            />
                            <Typography
                              variant="aclaracion"
                              sx={{
                                display: {
                                  xs: "inline",
                                  sm: "inline",
                                  md: "inline",
                                  lg: "none",
                                },
                              }}
                            >
                              {leyendaOrganismo}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} lg={10}>
                            <Box display="flex" flexDirection="row">
                              <TextField
                                id="organismo"
                                name="organismo"
                                label="Organismo que archivó"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={formik.values.organismo}
                                onChange={formik.handleChangeOrganismo}
                                error={
                                  formik.touched.organismo &&
                                  Boolean(formik.errors.organismo)
                                }
                                helperText={
                                  formik.touched.organismo &&
                                  formik.errors.organismo
                                }
                                disabled
                              />
                              {buscandoOrganismo ? (
                                <CircularProgress
                                  color="primary"
                                  size={20}
                                  sx={{ margin: 1 }}
                                />
                              ) : (
                                  <BuscadorOrganismo
                                    resultado={handleOrganismo}
                                    activo={"T"}
                                    alta={"N"}
                                    accion="consulta"
                                  />
                                )}
                            </Box>
                          </Grid>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              lg={12}
                              sx={{ ml: 1, mt: 0, mb: 0, pt: 0 }}
                            >
                              <Typography
                                variant="aclaracion"
                                sx={{
                                  display: {
                                    xs: "none",
                                    sm: "none",
                                    md: "none",
                                    lg: "inline",
                                  },
                                }}
                              >
                                {leyendaOrganismo}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={4} sx={{ mb: 0 }}>
                    <Card>
                      <CardContent sx={{ padding: 1, height: "115px" }}>
                        <Typography variant="cuerpo">
                          Fecha de archivado
                        </Typography>
                        <Divider />
                        {/* aquí divido en 2 celdas */}
                        <Grid container spacing={1}>
                          <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ marginTop: 2 }}
                              error={
                                formik.touched.fechaDesde &&
                                Boolean(formik.errors.fechaDesde)
                              }
                              fullWidth
                            >
                              <TextField
                                id="fechaDesde"
                                type="date"
                                value={formik.values.fechaDesde}
                                label="Fecha desde"
                                variant="outlined"
                                size="small"
                                onChange={handleChangeFechaDesde}
                                InputLabelProps={{ shrink: true }}
                              />
                              <FormHelperText>
                                {formik.touched.fechaDesde &&
                                  formik.errors.fechaDesde}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6} lg={6} sx={{ mb: 1 }}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ marginTop: 2 }}
                              error={
                                formik.touched.fechaHasta &&
                                Boolean(formik.errors.fechaHasta)
                              }
                              fullWidth
                            >
                              <TextField
                                id="fechaHasta"
                                type="date"
                                value={formik.values.fechaHasta}
                                label="Fecha hasta"
                                variant="outlined"
                                size="small"
                                onChange={handleChangeFechaHasta}
                                InputLabelProps={{ shrink: true }}
                              />
                              <FormHelperText>
                                {formik.touched.fechaHasta &&
                                  formik.errors.fechaHasta}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>
                        {/* Fin de 2 celdas */}
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} lg={12} sx={{ mt: 0, mb: 0, pt: 0 }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          error={
                            formik.touched.ubicacion && Boolean(formik.errors.ubicacion)
                          }
                          fullWidth
                        >
                          <TextField
                            id="ubicacion"
                            name="ubicacion"
                            label="Ubicación física"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={formik.values.ubicacion}
                            onChange={handleChangeUbicacion}
                            sx={{ paddingTop: 0 }}
                            error={formik.touched.ubicacion && Boolean(formik.errors.ubicacion)}
                            helperText={formik.touched.ubicacion && formik.errors.ubicacion}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ mt: 0, paddingTop: 0, pl: 2, pr: 1, paddingLeft: 1 }}>
              <Grid item lg={12} xs={12} align="right" sx={{ pt: 0 }}>
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <Button
                    variant="plata"
                    type="reset"
                    sx={{ m: 1 }}
                    endIcon={<CachedIcon />}
                  >
                    Limpiar
                  </Button>{" "}
                  <Button
                    variant="gris"
                    type="submit"
                    disabled={submitting}
                    sx={{ m: 1 }}
                    endIcon={<SearchIcon />}
                  >
                    {submitting ? "Buscando..." : "Buscar"}
                  </Button>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  <IconButton color="primary" type="reset" title="Limpiar">
                    <CachedIcon />
                  </IconButton>{" "}
                  <IconButton
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    title="Buscar"
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
      <br></br>
      <Card>
        <CardContent>
          <EnhancedTableToolbar
            numSelected={selected.length}
            selected={selected}
            datos={datos}
            soporte={formik.values.soporte}
            fechaDesde={formik.values.fechaDesde}
            fechaHasta={formik.values.fechaHasta}
            orfId={formik.values.orfId}
            organismoDesc={formik.values.organismo}
            ubicacion={formik.values.ubicacion}
            tipoTramite={formik.values.tipoTramite}
            fechasPdf={fechasPdf}
            tipoTramitePdf={tipoTramitePdf}
            nroExpediente={formik.values.nroExpediente}            
          />
          <TableContainer>
            <Table
              sx={{ minWidth: 750, border: "1px solid #dee2e6" }}
              aria-labelledby="tableTitle"
              size="small"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={datos.length}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
                {stableSort(datos, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((dato, index) => {
                    const isItemSelected = isSelected(dato);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    
                    const resetearTabla = (event) => {
                      buscarTramites(formik.values)
                    };

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={dato.id}
                        selected={isItemSelected}
                        sx={
                          index % 2 === 0
                            ? { backgroundColor: "#f2f2f2" }
                            : { backgroundColor: "#fff" }
                        }
                      >
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          sx={{ pl: 2 }}
                        >
                          {
                            tipoTramite === "expediente"
                              ? dato.expediente
                              : dato.expediente ? null : dato.tramiteInterno
                          }
                        </TableCell>
                        <TableCell align="left">{dato.asunto}</TableCell>
                        <TableCell align="left">{moment(dato.fechaArchivo, "YYYY-MM-DD").format('DD/MM/YYYY')}</TableCell>
                        <TableCell align="left">
                          {dato.descOrgArchCompleta}
                        </TableCell>
                        <TableCell align="left">{dato.folios}</TableCell>
                        <TableCell align="left">{dato.ubicacion}</TableCell>
                        <TableCell align="left">{dato.vigente}</TableCell>
                        <TableCell align="center">
                          <Grid container spacing={1} sx={{ mt: 0, paddingTop: 0, pl: 2, pr: 1, paddingLeft: 1 }}>
                            <Grid item lg={6} xs={6} align="right" sx={{ pt: 0 }}>
                              { dato.vigente === "Sí" ? (                                                        
                                <Accion funcion={props.funcion} accion="editar_archivo">
                                <Archivar
                                  activo={"S"}
                                  mostrar="edicion"
                                  numSelected={1}
                                  datos={[
                                    { id: dato.id, 
                                    expediente: dato.expediente,
                                    tramiteInterno: dato.tramiteInterno,
                                    expedienteConFecha: dato.expedienteConFecha, 
                                    fechaExpediente: dato.fechaExpediente, 
                                    tramiteInternoConFecha: dato.tramiteInternoConFecha, 
                                    fechaTramiteInterno: dato.fechaTramiteInterno,                               
                                    asunto: dato.asunto, 
                                    soporte: dato.soporte, 
                                    ubicacion: dato.ubicacion,
                                    fechaArchivo: dato.fechaArchivo,
                                    recibido: "", 
                                    folios: dato.folios,
                                    observacion: dato.observacion},
                                    ]}
                                  resultado={resetearTabla}
                                  submitting={submitting}
                                />             
                                </Accion>                 
                              ) : (                              
                                <IconButton
                                  title="Editar"
                                  size="small"
                                  disabled={true}                              
                                >
                                  <EditOutlined fontSize="small" />
                                </IconButton>                              
                              )}
                            </Grid>          
                            <Grid item lg={6} xs={6} align="right" sx={{ pt: 0 }}>
                              <Accion funcion={props.funcion} accion="recircular">
                                <ConfirmDialog
                                  text="Vas a recircular el trámite"
                                  subText="¿Querés continuar?"
                                  icon={<RestorePageOutlinedIcon fontSize="small" />}
                                  iconTitle="Recircular"
                                  handleConfirm={() => recircular(dato.id, formik.values.tipoTramite, formik.values.nroExpediente)}
                                  data={dato.id}
                                  mostrar={dato.vigente === "Sí" ? 'S' : 'N'}
                                />
                                {/* <IconButton
                                  title="Recircular"
                                  size="small"
                                  disabled = {dato.vigente === "Sí" ? false : true}
                                  onClick={() => recircular(dato.id, formik.values.tipoTramite, formik.values.nroExpediente)}                                 
                                >
                                  <RestorePageOutlinedIcon fontSize="small" />
                                </IconButton>                                        */}
                              </Accion>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {submitting ? (
                  <TableRow>
                    <TableCell colSpan="8" align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {datos.length === 0 && !submitting ? (
                  <TableRow>
                    <TableCell colSpan="8" align="center">
                      <Typography variant="aclaracion">No hay datos para mostrar</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                    null
                  )}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 53 * emptyRows,
                    }}
                  >
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "Todos", value: datos.length },
                    ]}
                    count={datos.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    selected={selected}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </MinimalPage>
  );
};

export default ConsultaArchivados;